import { useAiChat } from './useAiChat';
import type { UseAiChatReturn } from './useAiChat';

export type { UseAiChatReturn as UsePlayerAiReturn };

/**
 * A player's chat with Tia: the same hook as the GM's, on /ai/player-chat — his own box «Allow changes»
 * (unticked → a plan applied as him, ticked → his own things at once), the card of his answer with an undo,
 * no focus, no models, no tool lines, nothing of the GM's.
 */
export function usePlayerAi(): UseAiChatReturn {
  return useAiChat({ player: true });
}
